type Props = {
    iconClass: string;
    style?: React.CSSProperties;
}

const NavItemIcon = ({iconClass, style = {}}: Props) => {
    return (
        <span
            className={`fas ${iconClass} fa-fw mr-3`}
            style={{marginRight: "3px", marginTop: "5px", ...style}}
        />
    )
}

export default NavItemIcon;
